import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './index.css';
import { IS_MOCK } from '@/api/client';
import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import { initObservability } from '@/lib/observability';

// Sentry only when a DSN is configured (runtime env.js or VITE_SENTRY_DSN); otherwise a no-op.
initObservability();

async function enableMocks(): Promise<void> {
  if (!IS_MOCK) return;
  const { worker } = await import('@/mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass', quiet: true });
  document.documentElement.dataset.mock = '1';
}

void enableMocks().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
});
